<template>
  <base-page>
    <template #title>
      <span class="display-1 white--text font-weight-thin">
        {{ isLoading ? 'Invoice Detail' : invoiceTitle() }}
        <invoice-status-chip
          v-if="!isLoading"
          :invoice="invoice"
          :small="false"
        />
      </span>
    </template>
    <template #main>
      <v-row
        v-if="isLoading"
        align="center"
        justify="center"
      >
        <v-progress-circular
          :size="125"
          :width="7"
          color="primary"
          indeterminate
        />
      </v-row>
      <invoice-detail
        v-if="!isLoading"
        :invoice="invoice"
      />
    </template>

    <template #actionButton>
      <invoice-action-menu
        v-if="!isLoading"
        :invoice="invoice"
        @action="onAction"
      />
    </template>
  </base-page>
</template>
<script>
import BasePage from '@/views/BasePage.vue'
import InvoiceDetail from "./InvoiceDetail"
import { mapActions } from "vuex"
import { formatMoney } from "../../services/util.service"
import InvoiceStatusChip from "../../components/Invoice/InvoiceStatusChip"
import InvoiceStatusDialog from "../../components/Invoice/InvoiceStatusDialog"
import ConfirmAction from "../../components/Common/ConfirmAction"
import InvoiceActionMenu from "../../components/Invoice/InvoiceActionMenu"

export default {
  components: {
    InvoiceActionMenu,
    ConfirmAction,
    InvoiceStatusDialog,
    InvoiceStatusChip,
    InvoiceDetail,
    BasePage,
  },
  data() {
    return {
      isLoading: false,
      invoice: {}
    }
  },
  methods: {
    ...mapActions([ 'getInvoice' ]),
    invoiceTitle() {
      const { currency, total, number } = this.invoice || {}
      return number
        ? `${number} -- ${formatMoney({ amount: total, currency })}`
        : formatMoney({ amount: total, currency })
    },
    onAction() {
      this.loadInvoice()
    },
    loadInvoice() {
      if (this.$route.params.id) {
        const params = {
          _reload: true,
          id: this.$route.params.id,
          expand: [
            'payment_intent.charges.data.balance_transaction',
            'customer',
            'total_tax_amounts.tax_rate'
          ]
        }

        this.isLoading = true
        this.getInvoice(params)
          .then(invoice => {
            this.invoice = { ...invoice }
          })
          .finally(() => { this.isLoading = false })
      }
    }
  },
  created() {
    this.loadInvoice()
  }
}
</script>
